<template>
	<div class="container__crud">
		<div class="container__crudactions">
			<div class="container__crudactions__cruddownload">
				<div class="container__crudactions__cruddownload__crud">
					<Button
						:label="$t('deleteSelected')"
						color="trv-error"
						outlined
						icon="far fa-trash-alt"
						semantic-class="tiny"
						:disabled="isDeleteButtonDisabled"
						width-auto
						@click="toggleExclusionAlert"
					/>
					<Button
						:label="$t('create')"
						color="trv-default"
						semantic-class="tiny"
						width-auto
						@click="showNewModelForm"
					/>
					<ExclusionAlert
						v-if="showExclusionAlert"
						:items-to-delete="modelList.filter((item) => item.isCheckedToDelete)"
						@cancel="toggleExclusionAlert"
						@confirm="deleteModels"
					>
						<template #item="{ item }">
							<li class="exclusion-alert-item">{{ $t('code') }} : {{ item.mtge_cd_codigo }}</li>
						</template>
					</ExclusionAlert>
				</div>
				<!-- <div class="container__crudactions__cruddownload__download">
          <DownloadButton />
        </div> -->
			</div>
			<div class="container__crudactions__filtercollums">
				<div class="container__crudactions__filtercollums__filter">
					<InputSearch
						v-model="textFilter"
						style="margin-right: 0.5rem"
						:placeholder="$t('search')"
					/>
				</div>
				<div
					class="container__crudactions__filtercollums__collumns"
					style="display: flex"
				>
					<DropdownCheckbox
						v-model="tableHeaders"
						style="width: 85px; right: 4px"
					/>
					<Button
						:label="$t('export')"
						semantic-class="mini"
						color="trv-primary"
						outlined
						style="border-radius: 5px !important; width: 65px"
						@click="downloadCSVMaterialGenetico()"
					/>
				</div>
			</div>
		</div>
		<CrudTable
			:headers="headersAtivos"
			:data="modelsToBeShowedAndTotal.items"
			:table-configuration="tableConfiguration"
			:show-edit-model-form="showEditModelForm"
			@sortConfig="
				sortBy = $event.sortBy
				sortType = $event.sortType
			"
		>
			<template #outer-action-button="dataObject">
				<KebabMenu
					v-model="intention"
					:options="kebabOptions"
					:properties="dataObject"
				/>
			</template>
		</CrudTable>
		<div class="container__crud__pagination">
			<Pagination
				ref="ref__pagination"
				:quantity-per-page="10"
				:quantity-per-page-options="[10, 20, 30]"
				:total-records="modelsToBeShowedAndTotal.total"
				@setStartEnd="setStartEnd"
				@setQuantityPerPage="setQuantityPerPage"
			/>
		</div>
		<CrudForm
			:is-visible="showForm"
			:change-is-visible="changeFormAndCloseAllActions"
			:title-form="titleForm"
			:backdrop="true"
		>
			<template #form>
				<div style="display: flex; gap: 0.5rem; flex-direction: column">
					<DropdownFk
						v-model="model.fk_espe_especie"
						:dropdown-options="especies"
						:label="$t('specie') + '*'"
					/>
					<InputText
						v-model="model.mtge_cd_codigo"
						:label="$t('code') + '*'"
					/>

					<!-- <Accordion
            :label="$t('optionalFields')"
            :hints="[$t('description'), $t('location'), $t('provider')]"
          > -->
					<div style="display: flex; gap: 0.5rem; flex-direction: column" />
					<InputText
						v-model="model.mtge_ds_descricao"
						:label="$t('description')"
					/>
					<InputText
						v-model="model.mtge_ds_local_selecao"
						:label="$t('location')"
					/>
					<InputText
						v-model="model.mtge_nm_fornecedor"
						:label="$t('provider')"
					/>
					<InputText
						v-model="model.mtge_md_densidade"
						:label="`${$t('density')} (g/cm³)`"
						:mask="['#', '#.#', '#.##', '##.##', '###.##', '####.##', '#####.##', '######.##']"
					/>
					<InputText
						v-model="model.mtge_ds_procedencia"
						:label="$t('provenance')"
					/>
					<InputText
						v-model="model.mtge_ds_tipo_uso"
						:label="$t('typeOfUse')"
					/>
					<InputText
						v-model="model.mtge_nm_matriz"
						:label="$t('parentCompany')"
					/>
					<!-- </Accordion> -->
				</div>

				<div class="container__crud__crudform__buttons">
					<Button
						:label="$t('save')"
						color="trv-default"
						semantic-class="mini"
						:disabled="disableSaveButton || !camposObrigatoriosPreenchidos"
						@click="saveClick()"
					/>
					<Button
						:label="$t('cancel')"
						color="trv-default"
						semantic-class="mini"
						outlined
						@click="changeFormAndCloseAllActions"
					/>
				</div>
			</template>
		</CrudForm>
	</div>
</template>

<script>
import { v4 as uuidv4 } from 'uuid'

import Button from '../../../../components/Button/Button'
import CrudForm from '../../../../components/CrudForm/CrudForm'
import CrudTable from '../../../../components/CrudTable/CrudTable'
import DropdownCheckbox from '../../../../components/DropdownCheckbox/DropdownCheckbox'
import DropdownFk from '../../../../components/DropdownFk/DropdownFk'
import InputSearch from '../../../../components/InputSearch/InputSearch'
import InputText from '../../../../components/InputText/InputText'
import KebabMenu from '../../../../components/KebabMenu/KebabMenu'
import Pagination from '../../../../components/Pagination/Pagination'

import { getDropdownEspecies } from '@/services/requests/EspecieRequests'

import ControllingPaginationMixins from '../../../../mixins/ControllingPaginationMixins'
import RegistersMixins from '../../../../mixins/RegistersMixins'

import {
	createMaterialGenetico,
	deleteMaterialGeneticoByIdList,
	getAllMaterialGeneticos,
	updateMaterialGenetico,
} from '../../../../services/requests/MaterialGeneticoRequests'

import validarMaterialGenetico from '../../../../validations/MaterialGeneticoValidation'
import { exportarCsv } from '../../../../utils/csvHellpers'
import ExclusionAlert from '../../../../components/ExclusionAlert/ExclusionAlert.vue'

export default {
	components: {
		// Accordion,
		Button,
		CrudForm,
		CrudTable,
		KebabMenu,
		// DownloadButton,
		DropdownCheckbox,
		DropdownFk,
		InputSearch,
		InputText,
		Pagination,
		ExclusionAlert,
	},
	/**
	 * Mixins
	 * - ControllingPaginationMaxins: Mixin para controler a paginacao
	 * - RegistersMixins: Mixin com funções compartilhadas para realizar o CRUD
	 */
	mixins: [ControllingPaginationMixins, RegistersMixins],
	data() {
		return {
			intention: {},
			headersSelecionados: ['mtge_md_densidade', 'mtge_ds_descricao', 'especie', 'mtge_cd_codigo'],
			showExclusionAlert: false,
			/**
			 * Campos que devem ser feito bind para cadastro ou edicao de registro
			 */
			model: {
				id: '',
				mtge_cd_codigo: '',
				mtge_ds_descricao: '',
				mtge_ds_procedencia: '',
				mtge_ds_local_selecao: '',
				mtge_ds_tipo_uso: '',
				mtge_nm_fornecedor: '',
				mtge_nm_matriz: '',
				mtge_md_densidade: '',
				fk_espe_especie: '',
				mtge_tbe_espe_especie: '',

				especie: '',
			},
			/**
			 * Configuração da tabela
			 */
			tableConfiguration: {
				statusTable: this.$t('loading') + '...',
				subtitleCardPropertie: 'mtge_ds_descricao',
				titleCardPropertie: 'mtge_cd_codigo',
			},
			tableHeaders: [
				{ key: 'mtge_cd_codigo', value: this.$t('code'), isActive: true },
				{ key: 'espe_ds_nome', value: this.$t('specie'), isActive: true },
				{
					key: 'mtge_ds_descricao',
					value: this.$t('description'),
					isActive: true,
				},
				{
					key: 'mtge_md_densidade',
					value: this.$t('density'),
					isActive: true,
				},
				{
					key: 'mtge_ds_procedencia',
					value: this.$t('provenance'),
					isActive: false,
				},
				{
					key: 'mtge_ds_local_selecao',
					value: this.$t('location'),
					isActive: false,
				},
				{
					key: 'mtge_ds_tipo_uso',
					value: this.$t('typeOfUse'),
					isActive: false,
				},
				{
					key: 'mtge_nm_fornecedor',
					value: this.$t('provider'),
					isActive: false,
				},
				{
					key: 'mtge_nm_matriz',
					value: this.$t('parentCompany'),
					isActive: false,
				},
			],
			/**
			 *especies que será dispostas para bindar com material genetico
			 */
			especies: [],
		}
	},
	computed: {
		kebabOptions() {
			return [
				{
					value: 'editar',
					label: this.$t('edit'),
				},
			]
		},
		headersAtivos() {
			const ativos = this.tableHeaders.filter((f) => this.headersSelecionados.includes(f.key))

			ativos.forEach((f) => {
				f.isActive = true
			})

			return ativos
		},
		/**
		 * Retorna se os campos obrigatórios estão preenchidos
		 */
		camposObrigatoriosPreenchidos() {
			return this.model.mtge_cd_codigo && this.model.fk_espe_especie
		},
	},
	watch: {
		tableHeaders: {
			deep: true,
			handler(value) {
				this.headersSelecionados = value.filter((f) => f.isActive).map((m) => m.key)
			},
		},
		intention(value) {
			const model = this.modelList.find((model) => model.id === value.properties.id)

			switch (value.intent) {
				case 'editar':
					this.showEditModelForm(model)
					break
			}
		},
	},
	/**
	 * Antes de criar o objeto seta a quantidade de itens por pagina
	 * e a ordenacao da tabela
	 */
	created() {
		this.quantityPerPage = 10
		this.orderTable = ['mtge_cd_codigo']
		getAllMaterialGeneticos().then((response) => {
			const { result: materiaisGeneticos } = response.data
			materiaisGeneticos.forEach((materialGenetico) =>
				this.formataMaterialGeneticoParaCrud(materialGenetico),
			)
			this.modelList = materiaisGeneticos
			this.tableConfiguration.statusTable = this.$t('noRecordFound')
		})

		getDropdownEspecies().then((response) => {
			this.especies = response
		})
	},
	methods: {
		/**
		 * Cria o objeto que deve ser enviado para o backend para ser
		 * criado no banco de dados
		 */

		toggleExclusionAlert() {
			this.showExclusionAlert = !this.showExclusionAlert
		},
		createMaterialGeneticoToPost() {
			return {
				id: uuidv4(),
				mtge_cd_codigo: this.model.mtge_cd_codigo.trim(),
				mtge_ds_descricao: this.model.mtge_ds_descricao,
				mtge_ds_procedencia: this.model.mtge_ds_procedencia,
				mtge_ds_local_selecao: this.model.mtge_ds_local_selecao,
				mtge_ds_tipo_uso: this.model.mtge_ds_tipo_uso,
				mtge_nm_fornecedor: this.model.mtge_nm_fornecedor,
				mtge_nm_matriz: this.model.mtge_nm_matriz,
				mtge_md_densidade: this.model.mtge_md_densidade,
				fk_espe_especie: this.model.fk_espe_especie,
			}
		},

		downloadCSVMaterialGenetico() {
			let cabecalhoDoCsvMaterial = [
				'Código',
				'Espécie',
				'Descrição ',
				'Densidade',
				'Procedência',
				'Local',
				'Tipo de Uso',
				'Fornecedor',
				'Matriz',
			]
			const items = this.modelList

			const linhas = items.map((item) => [
				item.mtge_cd_codigo,
				item.mtge_tbe_espe_especie,
				item.mtge_ds_descricao,
				item.mtge_md_densidade,
				item.mtge_ds_procedencia,
				item.mtge_ds_local_selecao,
				item.mtge_ds_tipo_uso,
				item.mtge_nm_fornecedor,
				item.mtge_nm_matriz,
			])

			exportarCsv('export_mtgr_genetico', cabecalhoDoCsvMaterial, linhas)
		},
		/**
		 * Cria novo MaterialGenetico no banco de dados
		 */
		create() {
			const materialGenetico = this.createMaterialGeneticoToPost()
			const { isValid } = validarMaterialGenetico(materialGenetico, this.modelList)

			if (isValid) {
				createMaterialGenetico(materialGenetico).then((response) => {
					const { result: materialGenetico, isError } = response.data
					this.disableSaveButton = false

					if (!isError) {
						this.cleanModel()
						this.formataMaterialGeneticoParaCrud(materialGenetico)
						this.modelList.unshift(materialGenetico)

						this.showForm = false
						this.emptyValue = ''

						this.mutationShowMessage({
							messageTitle: this.$t('sucesso'),
							messageIcon: 'far fa-check-circle',
							messageType: 'success',
						})
					} else {
						this.mutationShowMessage({
							messageTitle: this.$t('erro'),
							messageIcon: 'far fa-check-circle',
							messageType: 'error',
						})
					}
				})
			} else {
				this.disableSaveButton = false

				this.mutationShowMessage({
					messageTitle: this.$t('erro'),
					messageIcon: 'far fa-check-circle',
					messageType: 'error',
				})
			}
		},

		/**
		 * Formata campos do model para exibir na tabela de crud
		 */
		formataMaterialGeneticoParaCrud(materialGenetico) {
			materialGenetico.isCheckedToDelete = false
			materialGenetico.mtge_md_densidade = materialGenetico.mtge_md_densidade?.toFixed(2)
		},

		/**
		 * Atualiza MaterialGenetico no banco de dados
		 */
		update() {
			updateMaterialGenetico(this.model).then((response) => {
				const { result: materialGenetico, isError } = response.data
				this.disableSaveButton = false

				if (!isError) {
					this.formataMaterialGeneticoParaCrud(materialGenetico)

					const indexMaterialGenetico = this.modelList
						.map((materialGenetico) => materialGenetico.id)
						.indexOf(materialGenetico.id)
					this.$set(this.modelList, indexMaterialGenetico, materialGenetico)

					this.showForm = false

					this.mutationShowMessage({
						messageTitle: this.$t('sucesso'),
						messageIcon: 'far fa-check-circle',
						messageType: 'success',
					})
				} else {
					this.mutationShowMessage({
						messageTitle: this.$t('erro'),
						messageIcon: 'far fa-check-circle',
						messageType: 'error',
					})
				}
			})
		},

		/**
		 * Exclui fazenda no banco de dados
		 */
		deleteModels(email) {
			var emailUsuario = localStorage.getItem('email')
			if (email === emailUsuario) {
				const existeRegistroComDependencia = this.modelList.filter(
					(materialGenetico) =>
						this.modelsIdWithCheckedToDelete.includes(materialGenetico.id) &&
						materialGenetico.possuiDependenciaDeRegistro,
				)

				if (existeRegistroComDependencia.length == 0) {
					const confirmResult = confirm('Deseja realmente excluir esses registros?')

					if (confirmResult) {
						deleteMaterialGeneticoByIdList(this.modelsIdWithCheckedToDelete).then(() => {
							this.modelsIdWithCheckedToDelete.forEach((f) => {
								const indexToRemove = this.modelList.map((m) => m.id).indexOf(f)
								this.modelList.splice(indexToRemove, 1)
							})

							this.mutationShowMessage({
								messageTitle: this.$t('sucesso'),
								messageIcon: 'far fa-check-circle',
								messageType: 'success',
							})
							this.showExclusionAlert = false
						})
					}
				} else {
					var materiaisGeneticosOrganizados = existeRegistroComDependencia
						.map(
							(materialGenetico) =>
								`• Material Genético: ${materialGenetico.mtge_cd_codigo} - ${materialGenetico.mtge_ds_descricao}`,
						)
						.join('<br/>')
					var message = `<b>${this.$t('dependenciaDePlantioOuCubagem')}:</b> <br/><br/> ${materiaisGeneticosOrganizados}`
					this.mutationShowMessage({
						messageTitle: this.$t('cuidado'),
						messageText: message,
						messageIcon: 'fas fa-exclamation-circle',
						messageType: 'warning',
					})
				}
			} else {
				this.mutationShowMessage({
					messageTitle: this.$t('wrongEmail'),
					messageIcon: 'fas fa-lock',
					messageType: 'error',
					messageText: this.$t('wrongEmaildescricao'),
				})
			}
		},

		/**
		 * Método executado quando clica no botão de salvar
		 */
		saveClick() {
			this.disableSaveButton = true
			if (this.isEdit) {
				this.update()
			} else {
				this.create()
			}
		},

		/**
		 * Configura para exibir o Model de edicao
		 */
		showEditModelForm(model) {
			this.model = Object.assign({}, model)

			this.titleForm = `${this.$t('edit')} ${this.$t('geneticMaterial')}`
			this.isEdit = true
			this.changeFormAndCloseAllActions()
		},

		/**
		 * Configura para exibir o Model de Cadastro
		 */
		showNewModelForm() {
			this.cleanModel()

			this.titleForm = `${this.$t('create')} ${this.$t('geneticMaterial')}`
			this.isEdit = false
			this.changeFormAndCloseAllActions()
		},

		/**
		 * Fecha o formulario e actions que estiverem abertas
		 */
		changeFormAndCloseAllActions() {
			this.showForm = !this.showForm
		},
	},
}
</script>

<style scoped src="../../../../css/crud.css"></style>
